import { render, staticRenderFns } from "./ConfigInmatic.vue?vue&type=template&id=0d341eaa"
import script from "./ConfigInmatic.vue?vue&type=script&lang=js"
export * from "./ConfigInmatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports